const LOGROCKET_APP_ID = process.env.LOGROCKET_APP_ID;

if (LOGROCKET_APP_ID) {
  const LogRocket = require("logrocket");
  LogRocket.init(LOGROCKET_APP_ID);
  require("logrocket-react")(LogRocket);
}
